import React from "react";
import logo from "./assets/logo.png";
import Counter from "./compoents/Counter";
import styled from "styled-components";
import moment from "moment";

const Wrapper = styled.div`
  background-color: #282c34;
  width: 100vw;
  display: grid;
  height: 100vh;
  overflow: hidden;
  grid-template-rows: 30vh 80vh;
  color: white;
`;

const Header = styled.header`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  img {
    height: 100%;
  }
`;

const Body = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 12px;
  font-size: 21px;
  gap: 12px;
`;

function App() {
  return (
    <Wrapper>
      <Header>
        <img src={logo} className="logo" alt="https://pathofexile2.com/" />
      </Header>
      <Body>
        Announce {moment(1732219200000).format("LL")}
        <Counter time={1732219200000} />
        <br />
        Early Access Launching {moment(1733515200000).format("LL")}
        <Counter time={1733515200000} />
      </Body>

    </Wrapper>
  );
}

export default App;
